import styles from './FaqPage.module.css';
import {  Link } from 'react-router-dom';
import { Faq } from '../FAQ/Faq'
import { Footer } from '../Footer/Footer';
import { Developer } from './Developer';
import { Header } from '../Header/Header';
import { Card, CardGroup, Col, Container, Form,InputGroup, FormControl, Accordion} from 'react-bootstrap';
import faq from '../../assets/imgs/faq.png';
import icon1 from '../../assets/icons/icon1.png';
import icon2 from '../../assets/icons/icon2.png';
import icon3 from '../../assets/icons/icon3.png';
import icon4 from '../../assets/icons/icon4.png';
import icon5 from '../../assets/icons/icon5.png';
import search from '../../assets/icons/search.png';


export const Support = () => {
  return (
    <div>
           <Header />
        <Container fluid style={{ backgroundColor: '#f0f4f8'}}>
        <Container>
          <Col >
          <div className={`mt-5 ${styles.textsec}`}>
          <h1 className={`${styles.title}`}>Hello, how can we help?</h1>
          <p  className={`${styles.desc}`}>Hi there! Is there a question bugging your mind about our services, you can 
        start by writing your question in the search bar below</p>
        
        </div>
        <div className={`${styles.formsec}`}>
        <InputGroup >
          <InputGroup.Text id="basic-addon1" className={`${styles.inputicon}`}><img src={search}  alt='search icon' /></InputGroup.Text>
        <FormControl type='search' name='search' aria-describedby="basic-addon1" placeholder='Write you would like to know here.........' className={`${styles.FormControl}`}/>
        </InputGroup>
        </div>
        <img src={faq} alt='icon' className={`${styles.faqimg}`} />
          </Col>
        </Container>
        </Container>


        <Container>
          <Col>
            <p className={`${styles.text}`}>Or choose a category to  to help you  find quickly 
            what you would like to know</p>

            <CardGroup lg={5} xs={1} sm={1} md={5} className={`gap-4 ${styles.cardgroup}`}>

          <Card className={`${styles.card}`} as={Link} to='/faq/business'>
                <Card.Img src={icon1} alt='card-icon' className={`${styles.icon}`} />
                <Card.Body>
                  <Card.Title className={`${styles.cardTitle}`}>Businesses</Card.Title>
                </Card.Body>
              </Card>

              <Card className={`${styles.card}`} as={Link} to='/faq/developer'>
                <Card.Img src={icon2} alt='card-icon' className={`${styles.icon}`} />
                <Card.Body>
                  <Card.Title className={`${styles.cardTitle}`}>Developers</Card.Title>
                </Card.Body>
                </Card>

              <Card className={`${styles.card}`} as={Link} to='/faq/others'>
                <Card.Img src={icon3} alt='card-icon' className={`${styles.icon}`} />
                <Card.Body>
                  <Card.Title className={`${styles.cardTitle}`}>Others</Card.Title>
                </Card.Body>
              </Card>

              <Card className={`${styles.card}`} as={Link} to='/faq/billing'>
                <Card.Img src={icon4} alt='card-icon' className={`${styles.icon}`} />
                <Card.Body>
                  <Card.Title className={`${styles.cardTitle}`}>Billing</Card.Title>
                </Card.Body>
              </Card>

              <Card className={`${styles.card}`}>
                <Card.Img src={icon5} alt='card-icon' className={`${styles.icon}`} />
                <Card.Body>
                  <Card.Title className={`${styles.cardTitle}`}>Support</Card.Title>
                </Card.Body>
              </Card>

            </CardGroup>
          </Col>
        </Container>

        <Container className={`${styles.section}`}>
            <Col lg={12} xs={12} sm={12} md={12} >
            <div className={` ms-lg-auto me-lg-auto ${styles.caption}`}>
                <h2 className={`${styles.faqtitle}`}> Businesses</h2>
                <p className={`${styles.faqdesc}`}> Lorem ipsum dolor sit amet consectetur, adipisicing elit. Porro est, culpa saepe quaerat perferendis officiis 
ipsam rem repudiandae quia voluptas voluptate aperiam tempora suscipit nobis. Iste, omnis. Maxime, repellendus at.'
</p>

            </div>

            <div className={`${styles.faq}`}>
           <Accordion className={`${styles.acc}`}>
  <Accordion.Item eventKey="0" className={`${styles.accItem}`}>
    <Accordion.Header className={`${styles.accTitle}`}>What minimum amount I can bring to build a website?</Accordion.Header>
    <Accordion.Body className={`${styles.accbody}`}>
    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
est laborum.
    </Accordion.Body>
  </Accordion.Item>

  <Accordion.Item eventKey="1" className={`${styles.accItem}`}>
    <Accordion.Header className={`${styles.accTitle}`}>Does this mean certain things will be missing from my webiste because 
of what i paid?</Accordion.Header>
    <Accordion.Body className={`${styles.accbody}`}>
    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
est laborum.
    </Accordion.Body>
</Accordion.Item>


       <Accordion.Item eventKey="6" className={`${styles.accItem}`}>
    <Accordion.Header className={`${styles.accTitle}`}>Does ULLWEB redesign existing website too?</Accordion.Header>
    <Accordion.Body className={`${styles.accbody}`}>
    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
est laborum.
    </Accordion.Body>
  </Accordion.Item> 

     <Accordion.Item eventKey="7" className={`${styles.accItem}`}>
    <Accordion.Header className={`${styles.accTitle}`}>Are there any hidden charges I should know about?</Accordion.Header>
    <Accordion.Body className={`${styles.accbody}`}>
    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
est laborum.
    </Accordion.Body>
  </Accordion.Item>  

</Accordion>
            </div>

            
            </Col>
        </Container>
        <Footer />
    </div>
  )
}
